import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import BookingModal from '../../utilities/BookingModal/BookingModal';
import AppointmentOption from '../AppointmentOption/AppointmentOption';

const AvailableAppointment = ({selectedDate}) => {
    const [appointmentOptions, setAppointmentOptions] = useState(null)
    const [modalInfo, setModalInfo] = useState(null)

    useEffect(()=>{
        fetch('appointmentOption.json')
        .then(res=>res.json())
        .then(data=>setAppointmentOptions(data))
    },[])
    return (
        <div>
            <section>
                <p className='text-primary font-bold text-center mt-5'>Available Appointments on {format(selectedDate, 'PP')}</p>

              <div className='grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-16'>
              {     appointmentOptions &&
                    appointmentOptions.map(option=><AppointmentOption
                    key={option._id}
                    appointmentOption ={option}
                    setModalInfo={setModalInfo}
                    ></AppointmentOption>)
                }
              </div>
              { modalInfo &&
                <BookingModal
                modalInfo={modalInfo}
                selectedDate={selectedDate}
                setModalInfo={setModalInfo}
                ></BookingModal>
              }
            </section> 
        </div>
    );
};

export default AvailableAppointment;